module.exports = __webpack_public_path__ + "static/media/flexibility.8a3fe114.png";